import { apiFetch } from './client';

export async function me() {
  const res = await apiFetch('/auth/me');
  return res.json();
}

export async function login(payload) {
  const res = await apiFetch('/auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function register(payload) {
  const res = await apiFetch('/auth/register', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return res.json();
}

// Email-code registration flow (RU backend)
export async function registerStart(payload) {
  const res = await apiFetch('/auth/register/start', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function registerVerify(payload) {
  const res = await apiFetch('/auth/register/verify', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function registerResend(payload) {
  const res = await apiFetch('/auth/register/resend', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return res.json();
}

// Bind email for existing accounts
export async function emailBindStart(payload) {
  const res = await apiFetch('/auth/email/start', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function emailBindVerify(payload) {
  const res = await apiFetch('/auth/email/verify', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function changePassword(payload) {
  // payload can be { new_password } or { current_password, new_password }
  const res = await apiFetch('/auth/change_password', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return res.json();
}

// Password reset flow
export async function resetStart(payload) {
  const res = await apiFetch('/auth/reset/start', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function resetVerify(payload) {
  const res = await apiFetch('/auth/reset/verify', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function resetResend(payload) {
  const res = await apiFetch('/auth/reset/resend', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function resetCheck(payload) {
  const res = await apiFetch('/auth/reset/check', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function resetSet(payload) {
  const res = await apiFetch('/auth/reset/set', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function logoutAll() {
  try {
    return await apiFetch('/auth/logout_all', { method: 'POST' });
  } finally {
    try { window.dispatchEvent(new Event('noesa:auth-cleared')); } catch {}
  }
}

export async function logout() {
  try {
    return await apiFetch('/auth/logout', { method: 'POST' });
  } finally {
    try { window.dispatchEvent(new Event('noesa:auth-cleared')); } catch {}
  }
}


